import { render, staticRenderFns } from "./TableSortBtn.vue?vue&type=template&id=768096a2&scoped=true"
import script from "./TableSortBtn.vue?vue&type=script&lang=js"
export * from "./TableSortBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768096a2",
  null
  
)

export default component.exports